import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { CarConfigStateType } from "../store";

export const SEARCH_FROM_LENGTH = 1;

export type CarConfigSpecsSearchActiveResultType = {
    groupId: string;
    categoryId?: string;
    itemId?: string;
};

export type CarConfigSpecsSearchType = {
    value: string;
    isSearching: boolean;
    activeResult: CarConfigSpecsSearchActiveResultType | null;
    activeFilters: string[];
};

export type CarConfigSpecsSearchActionsTypes = ReturnType<
    typeof setSearchValue | typeof setActiveResult | typeof setActiveFilters
>;

export const CarConfigSpecsSearchSlice = createSlice({
    name: "carConfigSpecsSearch",
    initialState: {
        value: "",
        isSearching: false,
        activeResult: null,
        activeFilters: [],
    } as CarConfigSpecsSearchType,
    reducers: {
        setSearchValue(state, action: PayloadAction<string>) {
            const isSearching = action.payload.trim().length >= SEARCH_FROM_LENGTH;
            state.value = action.payload;
            state.isSearching = isSearching;

            if (!isSearching) {
                state.activeFilters = [];
            }
        },
        setActiveResult(state, action: PayloadAction<CarConfigSpecsSearchActiveResultType | null>) {
            state.activeResult = action.payload;
        },
        setActiveFilters(state, action: PayloadAction<string[]>) {
            state.activeFilters = action.payload;
        },
    },
});

export const { setSearchValue, setActiveResult, setActiveFilters } = CarConfigSpecsSearchSlice.actions;

export const selectCarConfigSpecsSearchValue = (state: CarConfigStateType): CarConfigSpecsSearchType["value"] =>
    state.carConfigSpecsSearch.value;

export const selectCarConfigSpecsSearchIsSearching = (
    state: CarConfigStateType,
): CarConfigSpecsSearchType["isSearching"] => state.carConfigSpecsSearch.isSearching;

export const selectCarConfigSpecsSearchActiveResult = (
    state: CarConfigStateType,
): CarConfigSpecsSearchType["activeResult"] => state.carConfigSpecsSearch.activeResult;

export const selectCarConfigSpecsSearchActiveFilters = (
    state: CarConfigStateType,
): CarConfigSpecsSearchType["activeFilters"] => state.carConfigSpecsSearch.activeFilters;
